<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path
      d="M7.293,30.707l1,1a1,1,0,0,0,1.414,0l15-15a1,1,0,0,0,0-1.414l-15-15a1,1,0,0,0-1.414,0l-1,1a1,1,0,0,0,0,1.414L20.586,16,7.293,29.293A1,1,0,0,0,7.293,30.707Z"
      fill="currentColor"
    ></path>
  </svg>
</template>
<script setup lang="ts"></script>
